import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import classNames from 'classnames';

import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import Input from '@material-ui/core/Input';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles';

import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';

import { AddButton, DeleteButton } from 'components/core';
import { ClientDialog } from 'components/admin/Dialogs';
const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  smallField: {
    maxWidth: '130px',
  },
  marginRight: {
    marginRight: theme.spacing.unit,
  },
  marginLeft: {
    marginLeft: theme.spacing.unit,
  },
  marginBottom: {
    marginBottom: theme.spacing.unit*2,
  },
  addRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
  },
  formControl: {
    width: '230px',
    margin: '0px',
    marginRight: theme.spacing.unit*2,
  },
  markupRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: theme.spacing.unit*2,
    marginBottom: theme.spacing.unit,
    width: '230px',
  }
});

class Rebill extends Component {
  constructor(props) {
    super(props);
    this.state = { showAddClient: false };
  }

  render() {
    const {
      classes,
      clients,
      showValidation,
      validation,
      projects,
      receipt,
      handleChange
    } = this.props;
    const { showAddClient } = this.state;

    return(
      <div className={classes.root}>
        <ClientDialog
          show={showAddClient}
          handleCreated={(result) => {
            handleChange("clientId", result);
          }}
          handleClose={() => this.setState({ showAddClient: false })}
        />
        <div className={classes.addRow}>
          <FormControl
            error={(showValidation && !!validation.validateField("clientId"))}
            className={classes.formControl}
          >
            <InputLabel htmlFor="client-simple">Client</InputLabel>
            <Select
              value={receipt.clientId === undefined ? "" : receipt.clientId}
              onChange={(event) => {
                handleChange("clientId", event.target.value);
              }}
              inputProps={{
                name: 'clientId',
                id: 'client-simple',
              }}
            >
              {clients &&
                clients.map((client, i) => {
                  return <MenuItem key={i} value={client.id}>{`${client.lastName}, ${client.firstName}`}</MenuItem>
                })
              }
            </Select>
            {showValidation && validation.validateField("clientId") &&
               <FormHelperText>{validation.validateField("clientId")}</FormHelperText>
             }
          </FormControl>
          <AddButton
            onClick={() => this.setState({ showAddClient: true })}
          />
        </div>
        <div className={classes.addRow}>
          <FormControl
            className={classes.formControl}
          >
            <InputLabel htmlFor="client-simple">Job (optional)</InputLabel>
            <Select
              value={receipt.projectId === undefined ? "" : receipt.projectId}
              onChange={(event) => {
                handleChange("projectId", event.target.value);
              }}
              inputProps={{
                name: 'jobId',
                id: 'job-simple',
              }}
            >
              {projects &&
                projects.map((project, i) => {
                  return <MenuItem key={i} value={project.id}>{project.jobCode}</MenuItem>
                })
              }
            </Select>
          </FormControl>
          <DeleteButton
            onClick={() => handleChange("projectId", null)}
          />
        </div>
        <div className={classes.markupRow}>
          <FormControl fullWidth style={{marginRight: "10px"}}>
            <InputLabel htmlFor="markup">Markup</InputLabel>
            <Input
              id="markup"
              type="number"
              value={receipt.markupPercent}
              onChange={(event) => handleChange("markupPercent", event.target.value)}
              startAdornment={<InputAdornment position="start">%</InputAdornment>}
            />
          </FormControl>
          <FormControl
            error={(showValidation && !!validation.validateField("charged"))}
            fullWidth
            style={{marginLeft: "10px"}}
          >
            <InputLabel htmlFor="charged">Charge Client</InputLabel>
            <Input
              id="charged"
              type="number"
              value={receipt.charged}
              onChange={(event) => handleChange("charged", event.target.value)}
              startAdornment={<InputAdornment position="start">$</InputAdornment>}
            />
            {showValidation && validation.validateField("charged") &&
              <FormHelperText>{validation.validateField("charged")}</FormHelperText>
            }
          </FormControl>
        </div>
      </div>
    );
  }
}


const mapStateToProps = (state, props) => {
  const { receipt } = props;
  const clients = state.clientsState;
  const client = clients.find(client => client.id === receipt.clientId);
  const projects = client && state.projectsState.filter(project => client.id === project.clientId);

  return {
    clients: clients,
    projects: projects,
  }
};

export default compose(
  withStyles(styles),
  connect(mapStateToProps)
)(Rebill);



// WEBPACK FOOTER //
// ./src/components/admin/Receipts/Dialog/Rebill.jsx